var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useState } from 'react';
export const VideoCarouselContext = createContext({});
export const VideoCarouselProvider = ({ videos, children, }) => {
    const [shouldCarouselPlay, setShouldCarouselPlay] = useState(true);
    const [isCarouselMuted, setIsCarouselMuted] = useState(true);
    let initialStartTimes = {};
    for (let i = 0; i < videos.length; i++) {
        initialStartTimes = Object.assign(Object.assign({}, initialStartTimes), { [i]: 0.0 });
    }
    const [carouselStartTimes, setCarouselStartTimes] = useState(initialStartTimes);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const storeTime = ({ index, currentTime, }) => {
        setCarouselStartTimes(Object.assign(Object.assign({}, carouselStartTimes), { [index]: currentTime }));
    };
    const getVideoProps = (_a) => {
        var { videoIndex, autoplay } = _a, rest = __rest(_a, ["videoIndex", "autoplay"]);
        return Object.assign({ autoplay: autoplay && shouldCarouselPlay, videoIndex: videoIndex, playButtonOnLoad: false, startTime: carouselStartTimes[videoIndex] }, rest);
    };
    return (React.createElement(VideoCarouselContext.Provider, { value: {
            getVideoProps: (args) => getVideoProps(args),
            isCarouselMuted,
            shouldCarouselPlay,
            setShouldCarouselPlay: (shouldPlay) => setShouldCarouselPlay(shouldPlay),
            isVideoPlaying,
            setIsVideoPlaying: (isPlaying) => setIsVideoPlaying(isPlaying),
            muteCarousel: () => setIsCarouselMuted(true),
            unMuteCarousel: () => setIsCarouselMuted(false),
            carouselStartTimes,
            storeTime: ({ index, currentTime, }) => storeTime({ index, currentTime }),
        } }, children));
};
//# sourceMappingURL=VideoCarouselContext.js.map